import { Component, OnInit, Input } from '@angular/core';
import { DBService } from 'src/app/services/db.service';
import { ModalController } from '@ionic/angular';
import { UtilService } from 'src/app/services/util.service';
import { Special } from 'src/app/models/special.model';

const MAX_IMAGE_SPECIALS: number = 28
const MAX_WEB_IMAGE_SPECIALS: number = 40


@Component({
  selector: 'app-image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.scss']
})
export class ImageGalleryComponent implements OnInit {
  @Input() specialObj: Special;


  indexs: number[] = []
  webindexs: number[] = []
  path: string;
  webpath: string;

  constructor(public db: DBService, private modalCtrl: ModalController, private util: UtilService) { }
 
  ngOnInit() {
    this.util.isModalOpen = true

    this.indexs = Array.from(Array(MAX_IMAGE_SPECIALS / 2).keys())
    this.path = 'assets/imgs/specials/special_'

    this.webindexs = Array.from(Array(MAX_WEB_IMAGE_SPECIALS / 2).keys())
    // this.webpath = 'http://www.barela.de/assets/special/'+this.db.currentRestaurantKey+'/special_'       //SSL Error
    this.webpath = 'https://www.wi-studium.com/barela/assets/special/'+this.db.currentRestaurantKey+'/special_'
  }

  getUrl(index, pos): string {
    return this.path + (index * 2 + pos) + '.jpg'
  }

  geWebtUrl(index, pos): string {
    return this.webpath + (index * 2 + pos) + '.jpg'
  }

  selectImage(imgUrl: string) {
    this.specialObj.img = imgUrl
    this.modalCtrl.dismiss(this.specialObj)

  }

}
